import { Text } from '@react-pdf/renderer'
import React from 'react'
import styles from '../styles'

export default function CertificateName({ name }: Props) {
    const font = getFontOptions(name)

    return (
        <Text 
            hyphenationCallback={word => customHyphenationCallback(word, font.limit)} 
            style={[
                styles.h1,
                {fontSize: font.size, marginBottom: font.mgb}
            ]}>
            {name}
        </Text>
    )
}

function getFontOptions(name: string) {
    const length = name.length
    
    if (length < 10)
        return { size: '72px', limit: 8, mgb: '25px' }

    if (length < 18)
        return { size: '64px', limit: 10, mgb: '20px' }

    if (length < 24)
        return { size: '48px', limit: 14, mgb: '20px' }
    
    return { size: '36px', limit: 18, mgb: '10px' }
}

function customHyphenationCallback(word: string, limit: number): string[] {
    if (word.length <= limit) 
        return [word]

    const middle = Math.floor(word.length / 2)
    const parts = [word.substr(0, middle), word.substr(middle)]
    return parts
}

interface Props {
    name: string
}